export enum ShipHistoryEnum {
    CHANGE_STATUS = 0,
    DELTE_STORER = 1,
    MOVE_SHIP_STORER = 2,
    MOVE_SHIP_CONFIG_LOAD = 3
  }